import {Box, useMediaQuery} from '@mui/material';
import {styles} from './MobMenu.styles';
import {NavLink} from 'react-router-dom';
import {ReactComponent as SilentIcon} from '@icons/sidebar/silent-bid.svg';
import {ReactComponent as DashboardIcon} from '@icons/sidebar/dashboard.svg';
import {ReactComponent as JudgeIcon} from '@icons/sidebar/judge.svg';
import {ReactComponent as LiveIcon} from '@icons/sidebar/live-bid.svg';
import {ReactComponent as TiketStarIcon} from '@icons/sidebar/ticket-star.svg';
import {ReactComponent as TicketIcon} from '@icons/sidebar/ticket.svg';
import {ReactComponent as MoneyIcon} from '@icons/sidebar/money.svg';
import {ReactComponent as QuestionIcon} from '@icons/sidebar/question.svg';
import {ROUTER_URL} from '@/utils/enums';
import ActionUserNotLogined from '@/components/User/ActionUserNotLogined';
import {useSelector} from 'react-redux';
import {getUserSelector} from '@/store/user';
import {useEffect} from 'react';
import {getCurrentEventSelector} from '@/store/organization-event';

const MobMenu = ({onClose}: {onClose: () => void}) => {
	const user = useSelector(getUserSelector);
	const currentEvent = useSelector(getCurrentEventSelector);

	const isMobile = useMediaQuery('(max-width:767px)');

	useEffect(() => {
		const originalStyle = window.getComputedStyle(document.body).overflow;
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = originalStyle;
		};
	}, []);

	return (
		<Box sx={styles.backdrop} onClick={onClose}>
			<Box sx={styles.wrapper} onClick={(e) => e.stopPropagation()}>
				<NavLink to="" end style={styles.menuItem} onClick={onClose}>
					<DashboardIcon />
					Event Info
				</NavLink>
				{!isMobile && (
					<NavLink to={ROUTER_URL.USER_TABLES} style={styles.menuItem} onClick={onClose}>
						<TicketIcon />
						My Tables and Tickets
					</NavLink>
				)}
				<NavLink to={ROUTER_URL.USER_ALL_ITEMS} style={styles.menuItem} onClick={onClose}>
					<JudgeIcon />
					All Items
				</NavLink>
				<NavLink to={ROUTER_URL.USER_SILENT_AUCTION} style={styles.menuItem} onClick={onClose}>
					<SilentIcon /> Silent Auction
				</NavLink>
				<NavLink to={ROUTER_URL.USER_LIVE_AUCTION} style={styles.menuItem} onClick={onClose}>
					<LiveIcon /> Live Auction
				</NavLink>
				{currentEvent?.isRaffle && (
					<NavLink to={ROUTER_URL.USER_RAFFLE} style={styles.menuItem} onClick={onClose}>
						<TiketStarIcon /> Raffle
					</NavLink>
				)}
				{currentEvent?.isFundTheMission && (
					<NavLink to={ROUTER_URL.USER_FUND_MISSIONS} style={styles.menuItem} onClick={onClose}>
						<MoneyIcon /> Fund the mission
					</NavLink>
				)}
				<NavLink to={ROUTER_URL.USER_HELP_AND_SUPPORT} style={styles.menuItem} onClick={onClose}>
					<QuestionIcon /> Help & Support
				</NavLink>
				{!user && (
					<Box sx={styles.btnWrapper}>
						<ActionUserNotLogined title="Login" onClose={onClose} />
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default MobMenu;
